import React from 'react'
import { FaWhatsapp } from "react-icons/fa";
const Support = () => {
  return (
     <div className="w-full flex flex-col gap-4">
            {/* child-1 */}
            <div className="w-full flex flex-col gap-4 bg-[#00294B] rounded-md">
                <h2 className="p-4 text-2xl font-bold text-white">Support</h2>
                <span className="border-b border-[#22BEFF33]"></span>
               <div className='p-4  mt-[1rem]'>
                    <div className='bg-[#101e2b] sm:w-[20rem] w-full  p-[2rem] rounded-md flex gap-4 items-center'>
                        <div className='w-[3.5rem] h-[3.5rem] border border-[#254635] rounded-full flex justify-center items-center'>
                            <FaWhatsapp className='text-[#00E573] text-2xl'/>
                        </div>
                        <div className='flex flex-col gap-2 text-xl  text-white'>
                            <span>Whatsapp Support</span>
                            <span className='text-gray-500'>0162225677</span>

                        </div>
                    </div>

               </div>
    
            </div>
    
           
    
        </div>
  )
}

export default Support